// extracted by mini-css-extract-plugin
export default {"error":"PlanesFavoritos_error__nS0au","listaPlanesFavoritos":"PlanesFavoritos_listaPlanesFavoritos__ws1VU"};